import React, { useEffect } from 'react'
import { useTimeout } from './useTimeout'
import { ToastProps } from './Toast.types'
import Text from '../Text'
import Box from '../Box'
import { StyledFlexToast } from './styled'

const Toast: React.FC<ToastProps> = ({
  color,
  onClick,
  label,
  clickLabel,
  render,
  duration,
  close,
  onClose,
  ...restProps
}) => {
  useTimeout(close, duration)

  useEffect(() => {
    return () => {
      onClose?.()
    }
  }, [])

  return render ? (
    <>{render(onClick)}</>
  ) : (
    <StyledFlexToast
      gap='16px'
      alignItems='center'
      textAlign='center'
      justifyContent='center'
      position='relative'
      borderRadius='8px'
      padding='12px 16px'
      aria-label='toast-wrapper'
      {...restProps}
    >
      <Box aria-label='toast-label'>
        <Text color={color}>{label}</Text>
      </Box>
      {clickLabel && onClick && (
        <Box
          cursor='pointer'
          onClick={() => {
            close()
            onClick()
          }}
          aria-label='toast-cta'
        >
          <Text color={color} weight='bold' aria-label='toast-cta-label'>
            {clickLabel}
          </Text>
        </Box>
      )}
    </StyledFlexToast>
  )
}

export default Toast
